/* eslint-disable no-nested-ternary */
import { useEffect } from 'react';
import Highcharts from 'highcharts';

const QualityChart = ({ qualityMatchPercentage, index }) => {
    let pieChart;
    const totalPercentage = 100;
    const topThresholdPercentage = 80;
    const averageThresholdPercentage = 50;

    const getColor = () => {
        if (qualityMatchPercentage > topThresholdPercentage) {
            return '#22992E';
        }
        return qualityMatchPercentage > averageThresholdPercentage ? '#FFBF1F' : '#C52A1A';
    };

    useEffect(() => {
        pieChart = new Highcharts.Chart({
            chart: {
                renderTo: `pie-one-${index}`,
                type: 'pie',
                width: 110,
                height: 110,
                spacingLeft: 0,
                spacingTop: 0,
                spacingBottom: 0,
                spacingRight: 0,
                backgroundColor: '#f2f2f2',
                alignTicks: false,
                animation: false,
            },
            credits: {
                enabled: false,
            },
            title: {
                text: typeof qualityMatchPercentage === 'number' ? `${qualityMatchPercentage}%` : 'NA',
                verticalAlign: 'middle',
                style: {
                    // color: '#FF00FF',
                    fontWeight: 'bold',
                    fontSize: 14,
                },
            },
            tooltip: {
                enabled: false,
                alignTicks: false,
                animation: false,
                shadow: false,
            },
            plotOptions: {
                pie: {
                    dataLabels: {
                        enabled: false,
                    },
                },
                series: {
                    states: {
                        hover: {
                            enabled: false,
                            animation: {
                                duration: 0,
                            },
                        },
                    },
                },
            },
            series: [
                {
                    type: 'pie',
                    name: 'Quality match percentage',
                    innerSize: '60%',
                    animation: false,
                    data: [
                        {
                            y: qualityMatchPercentage,
                            color: getColor(),
                        },
                        {
                            name: 'Other',
                            y: totalPercentage - qualityMatchPercentage,
                            color: '#DEDEDE',
                        },
                    ],
                },
            ],
        });
        return () => {
            pieChart.destroy();
        };
    }, [qualityMatchPercentage]);

    return (
        <div
            id={`pie-one-${index}`}
            style={{
                height: 100, float: 'right', position: 'relative',
            }}
        />
    );
};

export default QualityChart;
